import { SxProps, Theme } from '@mui/material';
import theme from '../../theme';

export const AppBarStyles: SxProps<Theme> = {
  backgroundColor: 'customColors.blue.900',
};

export const LogoBoxStyles: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  marginRight: '16px',
  paddingRight: '40px',
  position: 'relative',
  a: {
    display: 'flex',
    alignItems: 'center',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    right: 0,
    width: '1px',
    height: '32px',
    backgroundColor: 'customColors.blue.200',
    opacity: '.5',
  },
  '@media (max-width:1565px)': {
    img: {
      width: '65px',
    },
  },
  '@media (max-width:1460px)': {
    marginRight: '10px',
    paddingRight: '25px',
  },
  '@media (max-width:1390px)': {
    img: {
      width: '55px',
    },
  },
};

export const navigationLinkBtnStyles: SxProps<Theme> = {
  padding: '4px 24px',
  fontSize: '16px',
  fontWeight: 500,
  textTransform: 'uppercase',
  transition: '.2s ease',
  '&:hover': {
    color: 'customColors.blue.400',
  },
  '@media (max-width:1750px)': {
    fontSize: '14px',
    padding: '4px 15px',
  },
  '@media (max-width:1620px)': {
    fontSize: '13px',
    padding: '4px 12px',
  },
};

export const menuItemStyles: SxProps<Theme> = {
  fontSize: '16px',
  color: 'customColors.gray.950',
  width: '240px',
  '&:hover': {
    backgroundColor: 'customColors.gray.100',
  },
};

export const ChevronDownStyles: SxProps<Theme> = {
  marginLeft: '4px',
  fontSize: '20px',
  transition: '.2s ease',
};

export const VerticalLineStyles: SxProps<Theme> = {
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-37px',
    right: 0,
    width: '1px',
    height: '32px',
    backgroundColor: 'customColors.blue.200',
    opacity: '.5',
  },
};

export const CreateBtnStyles: SxProps<Theme> = {
  marginRight: '40px',
  '@media (max-width:1620px)': {
    marginRight: '25px',
    padding: '8px 15px',
    fontSize: '15px',
  },
  '@media (max-width:1390px)': {
    marginRight: '20px',
    padding: '8px 10px',
    fontSize: '13px',
    svg: {
      fontSize: '17px !important',
      marginRight: '-3px',
    },
  },
};

const destkopEndsAtBreakpoint = 1000;

export const NavigationLinksDesktopSx: SxProps<Theme> = {
  '@media (max-width:1430px)': {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, min-content)',
    alignItems: 'flex-start',
    justifyItems: 'flex-start',
    gap: '0 5px',
  },
  '@media (max-width:1310px)': {
    gridTemplateColumns: 'repeat(6, min-content)',
  },
  '@media (max-width:1222px)': {
    gridTemplateColumns: 'repeat(5, min-content)',
  },
  '@media (max-width:1136px)': {
    gridTemplateColumns: 'repeat(4, min-content)',
    gap: '0 10px',
  },
  '@media (max-width:1050px)': {
    gridTemplateColumns: 'repeat(4, min-content)',
    gap: '0 5px',
  },
  [`@media (max-width:${destkopEndsAtBreakpoint}px)`]: {
    display: 'none',
  },
};

export const NavigationLinksMobileSx: SxProps<Theme> = {
  [`@media (min-width:${destkopEndsAtBreakpoint + 1}px)`]: {
    display: 'none',
  },
};

export const DrawerSx: SxProps<Theme> = {
  [`@media (min-width:${destkopEndsAtBreakpoint + 1}px)`]: {
    display: 'none',
  },
};

export const HamburgerMenuSx: SxProps<Theme> = {
  width: 350,
};

export const MenuOpenIconContainerSx: SxProps<Theme> = {
  flexDirection: 'row',
  justifyContent: 'flex-end',
  padding: '8px 16px',
};

export const MenuOpenIconSx: SxProps<Theme> = {
  '*': {
    fill: theme.palette.customColors.gray[950],
    color: theme.palette.customColors.gray[950],
  },
};

export const EditClientBaseUrl = '/edit-client';
export const EditTemplateBaseUrl = '/edit-template';
export const EditTaskBaseUrl = '/edit-task';
